import { CycleGroup, StudyEntity, StudyEntityType } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { cycleGroupClient } from './CycleGroupClient';

const factory = createStudyEntityHookFactory<CycleGroup>(StudyEntityType.CycleGroup);

/**
 * Lists the {@link CycleGroup}s of an epoch configuration.
 *
 * The cycle numbers a group produces are derived from its periods and their iteration counts, so a
 * change to either has to redraw them - hence the dependent entity types.
 */
export const useCycleGroups = factory.list(cycleGroupClient.list, [StudyEntityType.Epoch, StudyEntityType.Cycle]);

export const useCreateCycleGroup = factory.mutate((entity: CycleGroup) => cycleGroupClient.create(entity));
export const useUpdateCycleGroup = factory.mutate((entity: CycleGroup) => cycleGroupClient.update(entity));
export const useDeleteCycleGroup = factory.mutate((entity: StudyEntity) => cycleGroupClient.delete(entity));
